import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NormalValidation from "../Forms/FormValidation/unitsUsers/NormalValidation";

const UnitsUsersCreate = () => {
  document.title = "Orgãos de Estrutura de Membros - Khozi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Orgãos de Estrutura de Membros"
            breadcrumbItem="Novo Orgão de Estrutura de Membro"
          />
          <NormalValidation />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UnitsUsersCreate;
